export const LIST_BRANCH_CONFIGURATION_REQUEST =
  'LIST_BRANCH_CONFIGURATION_REQUEST'
export const LIST_BRANCH_CONFIGURATION_SUCCESS =
  'LIST_BRANCH_CONFIGURATION_SUCCESS'
export const LIST_BRANCH_CONFIGURATION_FAIL = 'LIST_BRANCH_CONFIGURATION_FAIL'

export const LIST_BRANCH_CONFIGURATION_SUMMARY_REQUEST =
  'LIST_BRANCH_CONFIGURATION_SUMMARY_REQUEST'
export const LIST_BRANCH_CONFIGURATION_SUMMARY_SUCCESS =
  'LIST_BRANCH_CONFIGURATION_SUMMARY_SUCCESS'
export const LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL =
  'LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL'

export const CREATE_BRANCH_CONFIGURATION_REQUEST =
  'CREATE_BRANCH_CONFIGURATION_REQUEST'
export const CREATE_BRANCH_CONFIGURATION_SUCCESS =
  'CREATE_BRANCH_CONFIGURATION_SUCCESS'
export const CREATE_BRANCH_CONFIGURATION_FAIL =
  'CREATE_BRANCH_CONFIGURATION_FAIL'

export const DETAIL_BRANCH_CONFIGURATION_REQUEST =
  'DETAIL_BRANCH_CONFIGURATION_REQUEST'
export const DETAIL_BRANCH_CONFIGURATION_SUCCESS =
  'DETAIL_BRANCH_CONFIGURATION_SUCCESS'
export const DETAIL_BRANCH_CONFIGURATION_FAIL =
  'DETAIL_BRANCH_CONFIGURATION_FAIL'

export const UPDATE_BRANCH_CONFIGURATION_REQUEST =
  'UPDATE_BRANCH_CONFIGURATION_REQUEST'
export const UPDATE_BRANCH_CONFIGURATION_SUCCESS =
  'UPDATE_BRANCH_CONFIGURATION_SUCCESS'
export const UPDATE_BRANCH_CONFIGURATION_FAIL =
  'UPDATE_BRANCH_CONFIGURATION_FAIL'

export const DELETE_BRANCH_CONFIGURATION_REQUEST =
  'DELETE_BRANCH_CONFIGURATION_REQUEST'
export const DELETE_BRANCH_CONFIGURATION_SUCCESS =
  'DELETE_BRANCH_CONFIGURATION_SUCCESS'
export const DELETE_BRANCH_CONFIGURATION_FAIL =
  'DELETE_BRANCH_CONFIGURATION_FAIL'

// export const LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL = 'LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL'
// export const LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL = 'LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL'
// export const LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL = 'LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL'

export const RESET_BRANCH_CONFIGURATION = 'RESET_BRANCH_CONFIGURATION'
